module.exports = __webpack_public_path__ + "static/media/Screenshot 2026-03-16 at 09.15.30.8d1a0028.png";